// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const SvgIconCheckboxIndetermined = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3H6zm2.112 8.374a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5z"
      fill="currentColor"
    />
  );
export default SvgIconCheckboxIndetermined;
